// Rotas do módulo Chat (PRD 2 — Comunicação Interna)
import { lazy } from "react";
import { ModuleRoutes } from "../types";

const ChatPage = lazy(() => import("@/pages/chat/ChatPage"));
const VoiceChannelsPage = lazy(() => import("@/pages/voice/VoiceChannelsPage"));
const HuddlePage = lazy(() => import("@/pages/huddle/HuddlePage"));
const StandupPage = lazy(() => import("@/pages/standup/StandupPage"));

export const chatRoutes: ModuleRoutes = {
  moduleId: "chat",
  basePath: "/mensagens",
  routes: [
    {
      path: "/mensagens",
      element: <ChatPage />,
      permission: { resource: "chat", action: "read" },
    },
    {
      path: "/voz",
      element: <VoiceChannelsPage />,
      permission: { resource: "voice_channels", action: "read" },
    },
    {
      path: "/huddle",
      element: <HuddlePage />,
      permission: { resource: "huddle", action: "read" },
    },
    {
      path: "/standup",
      element: <StandupPage />,
      permission: { resource: "huddle", action: "read" },
    },
  ],
};
